import { appRepo } from "@/repo/app-repo";
import { PlanData } from "@/entry/server/app";
import React, { useState, useEffect } from "react";
import LoadingGif from "@public/img/loading.gif";
import { formatPrice } from "@/utils/common_helpers";

export default function SubscriptionPage() {
    const [plans, setPlans] = useState<PlanData[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(function () {
        setLoading(true);
        appRepo.getPlans().then(function (res) {
            if (res.data) {
                setPlans(res.data);
            }
            setLoading(false);
        });
    }, []);

    return (
        <div className="profile-panel">
            <h2 className="profile-panel__title profile-panel__title--lg">قیمت اشتراک‌ها</h2>

            <p className="subscription-notice">
                برای خرید اشتراک، سایت را در گوشی یا کامپیوتر باز کنید.
            </p>

            {loading && (
                <div className="profile-panel__body profile-panel__body--center">
                    <div className="profile-panel__loading">
                        <img src={LoadingGif} alt="loading" />
                    </div>
                </div>
            )}

            {!loading && plans.length > 0 && (
                <div className="subscription-plans">
                    {plans.map(function (plan) {
                        return (
                            <div key={plan.id} className="subscription-plans__item">
                                <PlanCard plan={plan} />
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

function PlanCard({ plan }: { plan: PlanData }) {
    var cardClassName = "subscription-plan";
    if (plan.is_featured) {
        cardClassName = cardClassName + " featured-plan";
    }

    return (
        <div className={cardClassName}>
            <svg className="subscription-plan__icon" width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.8541 3.50067C12.4862 2.83311 11.5138 2.83311 11.1459 3.50067C10.9456 3.86432 10.7534 4.23285 10.5695 4.60602C9.99049 5.78115 9.49447 7.00233 9.08879 8.26238C8.95002 8.69339 8.53768 8.99275 8.06577 9.00528C6.9521 9.03484 5.84047 9.12648 4.73814 9.28206C4.42331 9.32649 4.11016 9.37595 3.79877 9.43035C3.02451 9.56562 2.73398 10.4484 3.2838 10.9864C3.40922 11.1091 3.5357 11.2308 3.66323 11.3515C4.61689 12.2537 5.62918 13.0978 6.69404 13.8779C7.06131 14.1469 7.21228 14.6084 7.07191 15.0297C6.63214 16.3496 6.29178 17.713 6.05943 19.1116C6.01284 19.3921 5.97058 19.674 5.93274 19.9573C5.83193 20.7119 6.64048 21.2448 7.3423 20.885C7.59281 20.7566 7.84111 20.6247 8.08712 20.4893C9.21586 19.8679 10.2965 19.1736 11.3222 18.4128C11.7204 18.1175 12.2796 18.1175 12.6778 18.4128C13.7035 19.1736 14.7841 19.8679 15.9129 20.4893C16.1589 20.6247 16.4072 20.7566 16.6577 20.885C17.3595 21.2448 18.1681 20.7119 18.0673 19.9573C18.0294 19.674 17.9872 19.3921 17.9406 19.1116C17.7082 17.713 17.3679 16.3496 16.9281 15.0297C16.7877 14.6084 16.9387 14.1469 17.306 13.8779C18.3708 13.0978 19.3831 12.2537 20.3368 11.3515C20.4643 11.2308 20.5908 11.1091 20.7162 10.9864C21.266 10.4484 20.9755 9.56562 20.2012 9.43035C19.8898 9.37595 19.5767 9.32649 19.2619 9.28206C18.1595 9.12648 17.0479 9.03484 15.9342 9.00528C15.4623 8.99275 15.05 8.69339 14.9112 8.26237C14.5055 7.00233 14.0095 5.78115 13.4305 4.60602C13.2466 4.23285 13.0544 3.86432 12.8541 3.50067Z" stroke="#E2E8F0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

            <p className="subscription-plan__label">اشتـــــــــــراک</p>
            <p className="subscription-plan__duration">
                <span className="subscription-plan__duration-value">{plan.duration}</span> روزه
            </p>

            <del className="subscription-plan__old-price">
                <span className="subscription-plan__old-price-value">{formatPrice(plan.price)}</span> تومان
            </del>

            <p className="subscription-plan__price">
                <span className="subscription-plan__price-value">{formatPrice(plan.discount_price)}</span>{" "}
                <span className="subscription-plan__price-currency">تومان</span>
            </p>
        </div>
    );
}
